import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

import exportKey from "../static/exportKey";

export default {
    getRiwayatPembayaranEdc: ({ commit, getters }, { idedc }) => {
        let query = {
            idedc,
            offset: getters.paginationRiwayatPembayaran.offset,
            limit: getters.paginationRiwayatPembayaran.limit,
        };
        commit("setFetching", true);
        conn.get(api.getRiwayatPembayaranEdc, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    conn.setQueryString(query);
                    if (status) {
                        commit("setListRiwayatPembayaran", data);
                        commit("setResponse", resulter.successResult(msg));
                        commit("setEndPembayaranOfPage", data.main_data[data.main_data.length - 1]);
                        commit("setNextPaginationRiwayatPembayaran", data.main_data);
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }
                }
                commit("setFetching", false);
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    exportListPembayaranEdc({ commit }, { idsettlement, idoutlet }) {
        let query = {
            idsettlement,
            idoutlet,
        };

        let formData = new FormData();
        formData.append("type", exportKey.listPembayaran.job);
        formData.append("filter_json", JSON.stringify(query));

        commit("setExporting", true);
        conn.post(api.export.job, formData, conn.contentType.form)
            .then((response) => {
                let { status, msg, data } = response.data;
                if (status === true) {
                    localStorage.setItem("key_export_riwayat_edc", exportKey.listPembayaran.tracker);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg, data));
                    commit("setExporting", false);
                }
            })
            .catch((e) => {
                commit("setExporting", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    exportPembayaranEdc({ commit }, { idedc }) {
        let query = {
            idedc,
        };

        let formData = new FormData();
        formData.append("type", exportKey.pembayaran.job);
        formData.append("filter_json", JSON.stringify(query));

        commit("setExporting", true);
        conn.post(api.export.job, formData, conn.contentType.form)
            .then((response) => {
                let { status, msg, data } = response.data;
                if (status === true) {
                    localStorage.setItem("key_export_edc", exportKey.pembayaran.tracker);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg, data));
                    commit("setExporting", false);
                }
            })
            .catch((e) => {
                commit("setExporting", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
};
